<template>
    <div>
        <FormulateForm class="formulate-form">
            <p class="body-copy body-copy--align-center">Haven’t received it?</p>

            <p class="body-copy body-copy--align-center">If your email is valid, we’ll email you a link to change your password.</p>

            <div class="formulate-form__form-footer">
                <FormulateInput
                    type="submit"
                    name="Send Again"
                    :input-class="'btn'"
                />

                <p class="formulate-form__footer-copy">Don’t have an account?
                    <router-link to="/join" class="formulate-form__link">Sign up now</router-link>
                </p>
            </div>
        </FormulateForm>
    </div>
</template>

<script>
    export default {
      name: 'PasswordEmailConfirmation',
    }
</script>